import { createFileRoute, Link, redirect } from "@tanstack/react-router";
import { Sparkles } from "lucide-react";

export const Route = createFileRoute("/")({
  beforeLoad: ({ context }) => {
    if (context.auth.status === "signedIn") throw redirect({ to: "/home" });
  },
  component: Landing,
});

function Landing() {
  return (
    <main className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="w-full max-w-sm rounded-2xl border border-slate-200 bg-white px-8 py-10 text-center shadow-sm">
        <Sparkles className="mx-auto text-teal-500" size={40} />
        <h1 className="mt-4 text-2xl font-semibold text-slate-800">Carwash</h1>
        <p className="mt-2 text-slate-500">
          Track your wash, save your vehicles, and see your history.
        </p>
        <Link
          to="/login"
          className="mt-6 inline-block w-full rounded-xl bg-teal-600 px-4 py-3 font-semibold text-white hover:bg-teal-700"
        >
          Sign in
        </Link>
      </div>
    </main>
  );
}
